import React, { Suspense } from 'react'
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { ContainerBody } from 'uiComponents/settingsContainer'
import { PageLoader } from 'uiComponents/loaders'
import UsersContainer from 'settings/users'
import UserListSection from 'settings/users/userListSection'
import { UserForm } from 'settings/users/userForm'

const UserRoutes = ({ match }: RouteComponentProps<BaseRouteParams>) => {
    return (
        <UsersContainer>
            <Switch>
                <Suspense fallback={<PageLoader />}>
                    <Route path="/account/:accountSlug/settings/users/user_list" component={UserListSection} />
                    <Route
                        path="/account/:accountSlug/settings/users/user_form/:id?"
                        render={() => (
                            <ContainerBody>
                                <UserForm />
                            </ContainerBody>
                        )}
                    />
                    <Route
                        render={() => <Redirect to={`/account/${match.params.accountSlug}/settings/users/user_list`} />}
                    />
                </Suspense>
            </Switch>
        </UsersContainer>
    )
}

export default UserRoutes
